import React, { useContext, useEffect } from 'react'
import { useLazyQuery, NetworkStatus } from '@apollo/client'
import { Paper, Typography } from '@material-ui/core'
import ChartColumnStacked from '../../../components/charts/ChartColumnStacked'
import ChartColumnSkeleton from '../../../components/skeletons/ChartColumnSkeleton'
import { ChartLineThemes } from '../../../components/charts/types/ChartLine'
import { GET_INCOME_SHARE_BY_CLIENT } from '../../../queries/factory'
import { FactoryFiltersContext } from '../../../context/FactoryFiltersContext'
import { formatCurrency } from '../../../utils/Helpers'

type ClientsBucket = {
  key: string,
  doc_count: number,
  total: {
    value: number
  }
}

interface BrandsBucket {
  key: string,
  doc_count: number,
  clients: {
    buckets: ClientsBucket[]
  }
}

type Series = {
  name: string
  data: number[]
}

const RevenueShare = (): JSX.Element => {
  const { filters } = useContext(FactoryFiltersContext)
  const [getData, { loading, error, data, networkStatus }] = useLazyQuery(
    GET_INCOME_SHARE_BY_CLIENT, {
      notifyOnNetworkStatusChange: true
    }
  )

  useEffect(() => {
    getData({
      variables: { filters }
    })
  }, [filters])

  if (networkStatus === NetworkStatus.refetch) return <ChartColumnSkeleton />
  if (loading || !data) return <ChartColumnSkeleton />
  if (error) return <p>Error :(</p>
  if (!data.aggregation.aggregations) return <p>No data found</p>

  const categories: Array<string> = []
  const series: Array<Series> = []
  const seriesMap: Map<string, number[]> = new Map()

  data?.aggregation?.aggregations?.brands?.buckets.map((brand: BrandsBucket) => {
    categories.push(brand.key)
    brand.clients?.buckets.map((client: ClientsBucket) => {
      if (seriesMap.has(client.key)) {
        const values = seriesMap.get(client.key)
        values!.push(client.total.value)
      } else {
        seriesMap.set(client.key, [client.total.value])
      }
    })
  })

  seriesMap.forEach((value, key) => {
    series.push({ name: key, data: value })
  })

  const options = {
    chart: {
      id: 'revenue-percentage',
      stackType: '100%'
    },
    xaxis: {
      categories
    },
    yaxis: {
      labels: {
        formatter: (value: number) => `${value} %`
      }
    },
    grid: {
      show: false
    },
    dataLabels: {
      enabled: true
    },
    tooltip: {
      y: {
        formatter: function (value: number) {
          return formatCurrency(value, 2)
        }
      }
    }
  }

  if (!data) return <></>

  return <Paper elevation={2}>
    <Typography paragraph style={{ paddingLeft: '20px', paddingTop: '20px' }}>Pedidos entregues e cancelados por device</Typography>
    <ChartColumnStacked options={options} series={series} theme={ChartLineThemes.multi} height={420} />
  </Paper>
}

export default RevenueShare
